import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    display: 'flex',
    heigth: 'auto',
  }),
);

themeStyles.addBaseStyles('ColumnContainer')(
  css({
    display: 'grid',
    gap: 'xxs',
    justifyContent: 'center',
    alignItems: 'flex-start',
  }),
);

themeStyles.addBaseStyles('ColorSwatchContainer')(
  css({
    display: 'flex',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('ColumnWrapper')(
  css({
    display: 'flex',
    width: '100%',
  }),
);

themeStyles.addBaseStyles('Label')(
  css({
    fontFamily: 'bold',
  }),
);

themeStyles.addBaseStyles('ColorName')(
  css({
    display: 'flex',
    wordWrap: 'wrap',
    mr: 'xs',
  }),
);
export default themeStyles;
